import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MultiselectHostComponent } from './../multiselect-host/multiselect-host.component';

@Component({
  selector: 'app-multiselect-group-checkmark',
  templateUrl: './multiselect-group-checkmark.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MultiselectGroupCheckmarkComponent {
  get checkboxValue(): boolean {
    return this.multiselectHost.areAllSelected;
  }

  @Output()
  valueChangedManually: EventEmitter<boolean> = new EventEmitter();

  constructor(private multiselectHost: MultiselectHostComponent) {}

  changeSelection(checked: boolean): void {
    this.multiselectHost.selectAll(checked);
    this.valueChangedManually.emit(checked);
  }

  buildTranslationKey(relativeKey: string): string {
    return `multiselect.${relativeKey}`;
  }
}
